module.exports = __webpack_public_path__ + "img/67589408000111.cadc588b.png";